import axios from "axios";

// Smart backend URL detection:
// - On preview/localhost: use REACT_APP_BACKEND_URL from env (Kubernetes ingress maps /api → backend)
// - On production custom domain (e.g. blisson.in): use current origin so API calls always hit the
//   same domain the user is browsing on. This avoids stale env-var mismatch after domain mapping.
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  if (typeof window === "undefined") return ENV_URL;
  const { hostname, origin } = window.location;
  const isPreview = hostname.includes("preview.emergentagent.com") || hostname.includes("emergent.host");
  const isLocal = hostname === "localhost" || hostname === "127.0.0.1";
  if (isPreview || isLocal) return ENV_URL || origin;
  // Production custom domain — always use current origin
  return origin;
}

const BACKEND_URL = resolveBackendUrl();
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_blisson-elegance/artifacts/4l9vaw03_Create_a_premium_luxury_cosmetic_202605221730.jpeg";

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/bbae1ed0-c75f-483a-8a50-56f6954a709e/images/d0fa6fa79dd2ae371542c668b0cfe88ffe7d225d057ace7ef81379e76c5f8f66.png";

export const PROMO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/bbae1ed0-c75f-483a-8a50-56f6954a709e/images/3f94296904e73e44bb7a51f31efe12f5a6398e35af13ead88875c91eb3d97618.png";

export const BEFORE_AFTER_IMG =
  "https://static.prod-images.emergentagent.com/jobs/bbae1ed0-c75f-483a-8a50-56f6954a709e/images/f266484cd4666c68b11c7c048dd8551d0b6150fa9231ee7350b67782bc9adec6.png";

export const CATEGORIES = [
  {
    name: "Hair Care",
    image:
      "https://images.unsplash.com/photo-1758188753373-5b01a0fc6d9d?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tagline: "Silk-strand restoration",
  },
  {
    name: "Skin Care",
    image:
      "https://images.pexels.com/photos/12115016/pexels-photo-12115016.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Editorial-skin formulas",
  },
  {
    name: "Facial Kits",
    image:
      "https://images.unsplash.com/photo-1556228720-195a672e8a03?auto=format&fit=crop&w=900&q=80",
    tagline: "Six-step salon ritual",
  },
  {
    name: "Wax Products",
    image:
      "https://images.unsplash.com/photo-1761718210055-e83ca7e2c9ad?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tagline: "Pro-grade smoothness",
  },
  {
    name: "Serums",
    image:
      "https://images.unsplash.com/photo-1760862652442-e8ff7ebdd2f8?crop=entropy&cs=srgb&fm=jpg&w=900&q=80",
    tagline: "Concentrated luminosity",
  },
  {
    name: "Professional Salon Essentials",
    image:
      "https://images.pexels.com/photos/3736398/pexels-photo-3736398.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tagline: "Tools of the trade",
  },
];

export const INSTAGRAM_FEED = [
  "https://images.unsplash.com/photo-1522335789203-aaa1f0a3b3d3?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1556228852-80b6e5eeff06?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1612817288484-6f916006741a?auto=format&fit=crop&w=600&q=80",
  "https://images.unsplash.com/photo-1570194065650-d99fb4bedf0a?auto=format&fit=crop&w=600&q=80",
];

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);
